<template>
  <section class="space-y-4">
    <THeading
      :level="3"
      tag="h3"
    >
      {{ t('booking.cancellationPolicyDetails.title') }}
    </THeading>

    <RvCancellationPolicy :start-date="bookingEstimateParams.dateStart" />
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()

const { bookingEstimateParams } = useBookingEstimate()
</script>

<i18n src="~~/i18n/locales/common/booking/cancellation-policy.json" lang="json" />
